import { createLayerComponent } from '@react-leaflet/core';
import L from 'leaflet';
import '@maplibre/maplibre-gl-leaflet';
import 'maplibre-gl/dist/maplibre-gl.css';

interface MapLibreTileLayerProps {
    styleUrl: string;
    attribution?: string;
}

/**
 * react-leaflet wrapper around the maplibre-gl-leaflet bridge.
 * Renders crisp vector tiles via MapLibre GL as a Leaflet layer,
 * so existing Leaflet markers/overlays keep working unchanged.
 */
const MapLibreTileLayer = createLayerComponent<L.Layer, MapLibreTileLayerProps>(
    ({ styleUrl, attribution }, ctx) => {
        const layer = L.maplibreGL({ style: styleUrl }) as unknown as L.Layer;
        // Leaflet's attribution control reads layer.options.attribution.
        if (attribution) (layer.options as L.LayerOptions).attribution = attribution;

        return { instance: layer, context: { ...ctx, layerContainer: undefined } };
    },
    (layer, props, prevProps) => {
        if (props.styleUrl !== prevProps.styleUrl) {
            const gl = (
                layer as unknown as {
                    getMaplibreMap?: () => { setStyle: (s: string) => void };
                }
            ).getMaplibreMap?.();
            gl?.setStyle(props.styleUrl);
        }
    }
);

export default MapLibreTileLayer;
